export default __webpack_public_path__ + "static/media/collection-received.2485fe88.svg";